export const SET_STORE_REQUEST_DETAILS = 'SET_STORE_REQUEST_DETAILS'
